import { render, staticRenderFns } from "./RiwayatAsetTanahPage.vue?vue&type=template&id=1b0336c1"
import script from "./RiwayatAsetTanahPage.vue?vue&type=script&lang=js"
export * from "./RiwayatAsetTanahPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports